import React from 'react';
import PropTypes from "prop-types";
import {
	createTheme,
	withStyles,
	makeStyles,
	ThemeProvider,
} from '@material-ui/core/styles';

import {
	Avatar,
	Box,
  Container,
  CssBaseline,
  Divider,
  Grid,
	Paper,
  Typography,
} from '@material-ui/core';

import styled from "styled-components/macro";
import Navigation from "./Navigation";


// const baseColor = "#E55578"
const baseColor = "#000"
const profilePicture = "https://portofolio-web.s3.ap-northeast-2.amazonaws.com/profile-picture.png";

const ProfilePicture = styled.img.attrs({
	src: `${profilePicture}`
})`
	max-width:100%;
	height: auto;
	border-radius: 50%;
	border: 0.1px solid rgb(0,0,0,0.3);
`;

const useStyles = makeStyles((theme) => ({
	divider: {
		margin: theme.spacing(4, 0),
		background: baseColor
		// background: "#fff"
	},
	profile: {
		[theme.breakpoints.up("xs")]: {
			width: "18.75rem !important"
		}
	},
	grid: {
		margin: "4rem",
		[theme.breakpoints.down("xs")]: {
			margin: "1rem"
		}
	},
	container: {
		padding: "1rem 4rem",
		[theme.breakpoints.down("xs")]: {
			padding: "0.5rem 2rem"
		}
	},
	header: {
		fontWeight: "bold",
		fontSize: "2rem",
		margin: "1.5rem 0"
	},
	subheader: {
		fontWeight: "bold",
		fontSize: "1.5rem",
		margin: "1.5rem 0",
	},
	subheader2: {
		fontSize: "1.5rem",
		margin: "1.5rem 0",
	},
	content: {
		fontSize: "1.125rem",
		margin: "1.5rem 0",
		whiteSpace: 'pre-line'
	},
	aboutMe: {
		[theme.breakpoints.up("md")]: {
			paddingLeft: "3rem !important"
		},
	}
}));

const customTheme = createTheme({
	typography: {
		fontFamily: [
			'Enriqueta', 'serif', '-apple-system', 'BlinkMacSystemFont','"Segoe UI"', 'Roboto', 
		].join(',')
	}
})

const experiences = [
	{
		position: 'Software Engineer',
		detail: 'Lawfully | Seoul | 2021 - Present',
		description: 'Responsible for the backend server development and improvement.'
	},
	{
		position: 'Software Engineer',
		detail: 'Tridge | Seoul | 2019 - 2021 (2 years)',
		description: 'Main Responsibilities:\n-> Server-side feature implementations for both the main website and internal website (Python/Django, GraphQL, PostgreSQL)\n-> Internal data analysis website development and maintenance (MongoDB, Express JS, React JS, Node JS - MERN stack)\n-> General QAs, bug fixings, and data dumpings/analysis\n-> Newsletter email implementations (Jinja)'
	},
	{
		position: 'Software Engineer',
		detail: 'GREW Creative Lab. | Incheon | 2019 (5 months)',
		description: 'Full server system development (REST APIs, database design and implementation, client-server communication)\n- Ethereum Smart Contract development\n- PDF virtual printer development\n- WinForm-based installer development\n- APIs documentation\n\nStack: C#, Java, Rest API, MySQL, Solidity'
	},
	{
		position: 'Software Engineer / Researcher',
		detail: 'iCONS Lab. | Suwon | 2017-2019 (2 years)',
		description: "Developed a machine learning-based prediction system for opportunistically offload workloads between clusters of drones. The code implementation and simulator are done in C/C++ with Network Simulator 3.\n\nFocused Research Topic: \nComputational Offloading, Drone Clusters, Machine Learning, Wireless Networks, Smart Vehicles\n\nInternational Publications:\n1. A Design and Simulation of the Opportunistic Computation Offloading with Learning-Based Prediction for Unmanned Aerial Vehicle (UAV) Clustering Networks† (Sensors Journal 2018 )\n2. Opportunistic computational offloading system for clusters of drones (ICACT 2018)\n3. A Reinforcement Learning based, Priority-aware Computational\nOffloading for Vehicular Networks (CoNEXT 2018)",
	},
]

const educations = [
	{
		major: 'Master of Science, Computer Engineering',
		detail: 'Ajou University | Mar 2017 - Dec 2019 | 4.36/4.50',
		description: 'Lorem ipsum is placeholder text commonly used in the graphic, print, and publishing industries for previewing layouts and visual mockups. ipsum is placeholder text commonly used in the graphic, print, and publishing industries for previewing layouts and visual mockups. ipsum is placeholder text commonly used in the graphic, print, and publishing industries for previewing layouts and visual mockups.		'
	},
	{
		major: 'Bachelor of Engineering, Electrical Engineering',
		detail: 'Bandung Institute of Technology | Aug 2012 - Jun 2016 | 3.61/4.00',
		description: 'Lorem ipsum is placeholder text commonly used in the graphic, print, and publishing industries for previewing layouts and visual mockups. ipsum is placeholder text commonly used in the graphic, print, and publishing industries for previewing layouts and visual mockups. ipsum is placeholder text commonly used in the graphic, print, and publishing industries for previewing layouts and visual mockups.		'
	},
]


function About(props) {
	const classes = useStyles();

  return (
    <React.Fragment>
			<Navigation />
			<ThemeProvider theme={customTheme}>
				<Container maxWidth="md">
				{/* <Container fixed> */}
					<Grid container spacing={2} className={classes.container}>
						<Grid item xs={4} md={3} lg={3} xl={3} style={{ textAlign: "left", paddingTop: "2rem" }}>
							<ProfilePicture className={classes.profile} />
						</Grid>
						<Grid item xs={11} md={8} lg={9} xl={9} className={classes.aboutMe}>
							<Typography variant="h4" align="left" className={classes.header}>
								About Me
							</Typography>
							<Typography align="left" className={classes.content}>
								Rico is a passionate software engineer with a solid background in computer engineering (software development, networking, IoT) and ~5 years experience in professional working experience. Proficient in programming languages and technologies such as (but not limited to): Django / Python, GraphQL, RESTful API, MySQL, MongoDB, Node.js, Java, C, C#, AWS, and Git.
							</Typography>
						</Grid>
					</Grid>

					<Divider className={classes.divider} />

					<Grid container spacing={1} className={classes.container}>
						<Grid item xs={11} md={11}>
							<Typography variant="h4" align="left" className={classes.header}>
								Experience
							</Typography>
						</Grid>
						{experiences.map((experience) => {
							return (
								<Grid item xs={11} md={11}>
									<Typography variant="h5" align="left" className={classes.subheader}>
										{experience.position}
									</Typography>
									<Typography variant="h6" align="left" className={classes.subheader2}>
										{experience.detail}
									</Typography>
									<Typography align="left" className={classes.content}>
										{experience.description}
									</Typography>
								</Grid>
							)
						})}
					</Grid>

					<Divider className={classes.divider} />

					<Grid container spacing={1} className={classes.container}>
						<Grid item xs={11} md={11}>
							<Typography variant="h4" align="left" className={classes.header}>
								Education
							</Typography>
						</Grid>
						{educations.map((education) => {
							return (
								<Grid item xs={11} md={11}>
								<Typography variant="h5" align="left" className={classes.subheader}>
									{education.major}
								</Typography>
								<Typography variant="h6" align="left" className={classes.subheader2}>
									{education.detail}
								</Typography>
								<Typography align="left" className={classes.content}>
									{education.detail}
								</Typography>
							</Grid>
							)
						})}
					</Grid>

					<Divider className={classes.divider} />

					<Grid container spacing={1} className={classes.container}>
						<Grid item xs={11} md={11}>
							<Typography variant="h4" align="left" className={classes.header}>
								Skills
							</Typography>
						</Grid>
						<Grid item xs={4} md={4} >
							<Typography align="left" className={classes.subheader2} >
								Python / Django
							</Typography>
							<Typography align="left" className={classes.subheader2} >
								Javascript
							</Typography>
							<Typography align="left" className={classes.subheader2} >
								Java
							</Typography>
							<Typography align="left" className={classes.subheader2} >
								C#
							</Typography>
							<Typography align="left" className={classes.subheader2} >
								C/C++
							</Typography>
						</Grid>
						<Grid item xs={4} md={4} >
							<Typography align="left" className={classes.subheader2} >
								SQL
							</Typography>
							<Typography align="left" className={classes.subheader2} >
								MongoDB
							</Typography>
							<Typography align="left" className={classes.subheader2} >
								React Js.
							</Typography>
							<Typography align="left" className={classes.subheader2} >
								Node Js.
							</Typography>
							<Typography align="left" className={classes.subheader2} >
								GraphQL
							</Typography>
						</Grid>
						<Grid item xs={4} md={4} >
							<Typography align="left" className={classes.subheader2} >
								REST API
							</Typography>
							<Typography align="left" className={classes.subheader2} >
								AWS
							</Typography>
							<Typography align="left" className={classes.subheader2} >
								HTML / CSS
							</Typography>
						</Grid>
					</Grid>

					<Divider className={classes.divider} />

					<Grid container spacing={1} className={classes.container}>
						<Grid item xs={11} md={11}>
							<Typography variant="h4" align="left" className={classes.header}>
								Languages
							</Typography>
						</Grid>
						<Grid item xs={4} md={4}>
							<Typography variant="h4" align="left" className={classes.subheader2}>
								English
							</Typography>
							<Typography align="left" className={classes.content}>
								Full professional proficiency
							</Typography>
						</Grid>
						<Grid item xs={4} md={4}>
							<Typography variant="h4" align="left" className={classes.subheader2}>
								Korean
							</Typography>
							<Typography align="left" className={classes.content}>
								Limited working proficiency
							</Typography>
						</Grid>
						<Grid item xs={4} md={4}>
							<Typography variant="h4" align="left" className={classes.subheader2}>
								Indonesian
							</Typography>
							<Typography align="left" className={classes.content}>
								Native proficiency
							</Typography>
						</Grid>
					</Grid>
				</Container>

			</ThemeProvider>
    </React.Fragment>
  )
}

export default About;